<template>
<div class="vm-login">

    <vm-card list :header="'Verified login'">
        <div>
            <vm-row>
                <vm-group c12>
                    <vm-label :text="'Epost'" />
                    <vm-input v-model="email" maxbo />
                </vm-group>
                <vm-group c12>
                    <vm-label :text="'Passord'" />
                    <vm-input v-model="password" maxbo password />
                </vm-group>
            </vm-row>
            <div style="text-align: right; float: left; width: 100%; margin-top: 10px;">
                <vm-button :text="'Logg inn'" :working="working" @clicked="login" :style="'width: 200px; margin-right: 5px;'" />
            </div>
        </div>
    </vm-card>

</div>
</template>
<script>
import { auth, envelopes } from '@verified/libvf';

import maxbo from '../../maxbo';

export default {
    name: 'Login',
    props: {
        header: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            email: '',
            password: '',
            working: false,
            authorizedCompanies: [
                { companyId: 'Hk7_2sKO-' },
                { companyId: 'BJXCP0aUw' }
            ],
            validCompanies: []
        }
    },
    methods: {
        
        async login() {
            this.working = true;
			try {
				this.token = await auth.login({
					email: this.email,
					password: this.password
                });

                // Get a list of all the user companies that are valid for the AML portal
                const companies = await auth.getCompanies();
                const list = [];
                for (const i in companies) list.push(companies[i].id);
                // Merge with company-info from Verified and add to list
                for (const i in this.authorizedCompanies) {
                    for (const j in companies) {
                        if (this.authorizedCompanies[i].companyId == companies[j].id) {
                            this.authorizedCompanies[i].vinfo = companies[j];
                            this.validCompanies.push(this.authorizedCompanies[i]);
                        }
                    }
                }
                console.log('valid', this.validCompanies);
                const company = this.validCompanies[0];

                await auth.setToken(this.token);

                let response;
                let authString = btoa(this.email + ':' + this.password);
                response = await maxbo.authorizeVerified(authString, company.companyId);
                console.log('response', response);

                this.$root.user.lambdaToken = response.data.token;
                this.$root.user.namespace = '/companies/' + company.companyId;

                const user = await auth.getUserinfo();
                console.log('user', user);

                await auth.authenticate({
					token: auth.token,
					namespace: this.$root.user.namespace
                });

                this.$root.user.firstName = user.givenName;
                this.$root.user.lastName = user.familyName;
                this.$root.user.email = user.email;
                this.$root.user.companyId = company.companyId;
                this.$root.user.isLoggedIn = true;

                console.log('user', this.$root.user);

			}catch(e) {
                console.log(e);
			}
            this.working = false;
        }

    }
}
</script>
<style>

.vm-login {
    max-width: 400px;
    margin: 0 auto;
    margin-top: 300px;
}

</style>